export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/forte-icon.svg?ef1c62d5b5ee456feeda9c3a899fd091";